module.exports = __webpack_public_path__ + "static/media/partager.f402ebe3.png";